import * as React from 'react';

import { RouteStore } from 'bernie-core';

import { RoomViewModel } from 'models';

import { UitkCardContent, UitkCardMedia, UitkCardTextSegment } from 'uitk-react-cards';
import { UitkFigure, UitkImage } from 'uitk-react-images';

import { ChooseDatesCTA } from './choose-dates-cta';
import { RoomDetails } from './room-details';
import { RoomDetailsRateOptionsWrapper } from './room-details-rate-options-wrapper';
import { RoomPhotos } from 'components/infosite/rooms-and-rates/room-photos';

export interface RatePlanControlViewProps {
  isDateless?: boolean;
  hasPhotos?: boolean;
  room?: RoomViewModel;
  position?: any;
  roomNameClass?: string;
  roomDetailsWrapperClass?: string;
  routeStore?: RouteStore;
  name?: any;
  hideRoomTitleToA11y?: boolean;
}

export const RatePlanControlView: React.FC<RatePlanControlViewProps> = ({
  isDateless,
  hasPhotos,
  room,
  position,
  roomNameClass,
  roomDetailsWrapperClass,
  routeStore,
  name,
  hideRoomTitleToA11y,
}: RatePlanControlViewProps) => (
  <section className="uitk-grid uitk-card-separator-bottom">
    {isDateless && (
      <UitkCardMedia>
        {!hasPhotos && <PlaceHolderImage />}
        {hasPhotos && (
          <RoomPhotos className="all-cell-1-4 all-r-padding-three" room={room} position={position} name={name} isDateless={true} />
        )}
      </UitkCardMedia>
    )}
    <UitkCardContent>
      {!isDateless && (
        <>
          {!hasPhotos && <PlaceHolderImage />}
          {hasPhotos && (
            <RoomPhotos className="all-cell-1-4 all-x-padding-three all-y-padding-three" room={room} position={position} name={name} />
          )}
        </>
      )}
      <div className={roomDetailsWrapperClass}>
        <RoomDetails
          amenityClasses={'uitk-type-left'}
          dataStid={'content-room-name-with-icon'}
          infoDialogClasses={roomNameClass}
          position={position}
          room={room}
          hideRoomTitleToA11y={hideRoomTitleToA11y}
        />
      </div>
      <div className="uitk-cell all-cell-fill">
        <RoomDetailsRateOptionsWrapper position={position} room={room} />
        {isDateless && (
          <UitkCardTextSegment data-stid="choose-date-cta-segment">
            <ChooseDatesCTA hotelPosition={position} routeStore={routeStore} />
          </UitkCardTextSegment>
        )}
      </div>
    </UitkCardContent>
  </section>
);

export const PlaceHolderImage = () => (
  <section className="placeholder_image all-cell-1-4 all-x-padding-three all-y-padding-three uitk-cell">
    <UitkFigure className="room__media">
      <UitkImage alt="" placeholderImage={true} />
    </UitkFigure>
  </section>
);
